export default __webpack_public_path__ + "static/media/liopleurodon.6af14e13.png";